import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Booking from "./pages/Booking";
import Affirmations from "./pages/Affirmations";
import About from "./pages/About";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/affirmations" element={<Affirmations />} />
            <Route path="/about" element={<About />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#1A1A1A",
              color: "#F7F5F2",
              border: "1px solid #42493D",
              borderRadius: "2px",
              fontFamily: "Outfit, sans-serif",
              fontWeight: 300,
              letterSpacing: "0.02em",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
